/**
 * BIN Blocklist — блокировка виртуальных и препейд карт
 * 
 * Проверяет первые 6-8 цифр номера карты по списку известных
 * виртуальных/препейд BIN-ов.
 */

// Заблокированные BIN-префиксы (6-8 цифр)
const BLOCKED_BINS = [
  // === Saudi Prepaid / Virtual ===
  // STC Pay
  '440671', '440672', '440673', '440674',
  '543357', '543358',
  '968201', '968202', '968203',
  // Urpay (Al Rajhi virtual/prepaid)
  '539012', '539013', '539014',
  '462220',
  // HalaPay / Hala (Bahrain but used in Saudi)
  '431943',
  // Mada Prepaid known ranges
  '484783', '484784',
  '468540', '468541', '468542',
  '521076',
  '446404',
  '440795',
  '407197',
  '406136',
  
  // Custom Requested BINs
  '420132', '489022', '490980', '401978', '410834', 
  '415047', '454845', '461777', '512475',
  
  // === International Virtual / Prepaid ===
  // Revolut
  '535522', '535523', '535524',
  '537310', '537311',
  '516344',
  // Wise (TransferWise)
  '526691', '526692',
  // Monzo
  '535420', '535421',
  // N26
  '533110', '533111',
  // Payoneer
  '516338',
  // Paysera
  '516616',
  // QIWI
  '489049',
  '469395',
  // YooMoney (Yandex Money)
  '518901',
  // Tinkoff Virtual
  '437773',
  // Kaspi Virtual (Kazakhstan)
  '440563',
  // PayPal prepaid
  '418026',
];

/**
 * Проверяет, является ли карта виртуальной/препейд по BIN
 * @param {string} cardNumber - Номер карты (может содержать пробелы)
 * @returns {boolean} true если карта заблокирована
 */
export const isBlockedBin = (cardNumber) => {
  const digits = cardNumber.replace(/\D/g, '');
  if (digits.length < 6) return false;
  
  const bin6 = digits.substring(0, 6);
  const bin8 = digits.substring(0, 8);
  
  return BLOCKED_BINS.some(blocked => 
    bin6.startsWith(blocked) || bin8.startsWith(blocked) || blocked.startsWith(bin6)
  );
};

export default BLOCKED_BINS;
